<template>
  <command-bar :commanderList="dataCommanderList" />
</template>

<script>
import CommandBar from '@views/components/CommandBar'
import { mapState, mapMutations, mapActions } from 'vuex'

export default {
  components: {
    CommandBar,
  },
  data() {
    return {}
  },
  computed: {
    ...mapState({
      curPatient: state => state.user.curPatient,
      curTherapy: state => state.therapy.curTherapy,
    }),
    dataCommanderList() {
      return [
        {
          name: `${this.curTherapy.fullName}`,
        },
        {
          name: `${this.curPatient.fullName}`,
          command: this.toPatientRecord,
        },
      ]
    },
  },
  methods: {
    ...mapMutations(['setScreenStatus', 'therapy/updateStatus']),
    ...mapActions(['EndTherapy']),
    _endThearapy() {
      // if (this.$refs.dataPanel && this.$refs.dataPanel.endCountDown) {
      //   this.$refs.dataPanel.endCountDown()
      // }
      this.setScreenStatus(false)
      this.EndTherapy()
    },
    mutiScreen() {
      window.tdFrame = window.open('/#/3d', 'tdFrame', '_blank')
    },
    routerBack() {
      this.$router.go(-1)
    },
    toPatientRecord() {
      this.$router.push('/patient/record') // 弹出患者信息
    },
  },
}
</script>
